import { createSelector } from 'reselect';
import { showSelector } from 'selectors/testTarget/offers/dynamicBottomNav/show/showSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

const showDynamicBottomNavSelector = createSelector(isTestTargetReadySelector, showSelector, (testReady, show) => testReady && show);

export { showDynamicBottomNavSelector };
